export const DASHBOARD = {
  "en-us": {
    titleKeyStatistics: "Key Statistics",
    titleAlertStatistics: "Alert Statistics",
    titleAllAlerts: "All Alerts",
    titleAlertsCountBreakdown: "Alerts Count/Breakdown",
    graphLegendAlertType: "Alert Type",
    titleOverallChargebacks: "Overall Chargebacks",
    titleAlertDetails: "Alert Details",
    titleAlertsStatusBreakdown: "Alert Status Breakdown",
    graphLegendStatusLabel: "Status Labels",
    graphLegendAlertUiStatus: "Alert UI Status",
    titleAlertsVsTransactions: "Alerts vs Transactions",
    controlDateRange: "Date Range",
    titleChargebacksByCardType: "Chargebacks by Card Type",
    graphLegendCardType: "Card Type",
    titleVisaChargebacks: "Visa Chargebacks",
    titleMastercardChargebacks: "Mastercard Chargebacks",
    titleChargebacksVsTransactions: "Chargebacks vs Transactions",
    titleVisaNetChargebacks: "Visa Net Chargebacks*",
    titleDiscoberChargebacks: "Discover Chargebacks",
    titleAmexChargebacks: "Amex Chargebacks",
    titleChargebackDetails: "Chargeback Details",
    titleKeyAccountStatistics: "Key Account Statistics",
    tableCbDate: "CB Date",
    tableCardType: "Card Type",
    tableCardBin: "Card Bin",
    tableLast4: "Card Last 4",
    tableTrxDate: "Trx Date",
    tableCurrency: "Currency",
    tableReasonCode: "Reason Code",
    tableReason: "Reason",
    tableAuthCode: "Auth Code",
    tableChargebackDetailsFooter: "*Visa Net Chargebacks is the Chargeback Count after removing RDRs that were misreported by your acquirer",
    tableFdCreateDateTime: "Create Date",
    tableCaseTypeLabel: "Case Type",
    tablePaymentDescriptor: "Payment Descriptor",
    tableTrxAmount: "Trx Amout",
    legend: "Legend",
    fdDateTimeWeek: "Date Time",
    transactionCountCustom: "Transaction Count (Custom)",
    transctionRateCustom: "Chargeback Rate (Custom)",
    controlDateType: "Date Type",
    tableCreateDataTime: "Create Date Time",
    deflectionServices: "Deflection Services",
    deflectionDataRequests: "Deflection Data Requests",
    wonDeflections: "Won Deflections",
    amountSaved: "Amount Saved",
    preventedFraudAndChargebacks: "Prevented Fraud (TC40) and Chargebacks",
    winningPercentage: "Win/Winning Percentage",
    deflectionDataRequestDetails: "Deflection Data Request Details",
    deflection: "Deflection",
    keyAccountStatisticsTitle: "Key Account Statistics",
    vampRate: "VAMP RATE",
    threshold: "Threshold is 1.5%",
    fraudTC40: "Fraud (TC40)",
    totalVampDisputes: "Total Vamp Disputes",
    totalVisaTransactions: "Total VISA Transactions",
    currenctVampRules: "Current VAMP Rules:",
    vampUpdates: "VAMP UPDATES:",
    vampMath: "All Visa Disputes plus All TC40 divided by All Visa Settled Transactions = VAMP rate",
    vampTextFinal: "Threashold is 1.5%  until Jan. 2026 but Visa is planning to adjust this ... we suspect upward.",
    totalFraudAndChargebackOverTimeTitle: "Total Fraud and Chargebacks Over Time",

  },

  "es-es": {
    titleKeyStatistics: "Estadísticas clave",
    titleAlertStatistics: "Estadísticas de alertas",
    titleAllAlerts: "Todas las alertas",
    titleAlertsCountBreakdown: "Desglose de la cantidad de alertas",
    graphLegendAlertType: "Tipo de alerta",
    titleOverallChargebacks: "Chargebacks generales",
    titleAlertDetails: "Detalles de alerta",
    titleAlertsStatusBreakdown: "Desglose del estado de alerta",
    graphLegendStatusLabel: "Etiquetas de estado",
    graphLegendAlertUiStatus: "Estado de la interfaz de alerta",
    titleAlertsVsTransactions: "Alertas vs Transacciones",
    controlDateRange: "Rango de fechas",
    titleChargebacksByCardType: "Chargebacks por tipo de tarjeta",
    graphLegendCardType: "Tipo de tarjeta",
    titleVisaChargebacks: "Chargebacks Visa",
    titleMastercardChargebacks: "Chargebacks Mastercard",
    titleChargebacksVsTransactions: "Chargebacks vs Transacciones",
    titleVisaNetChargebacks: "Chargebacks Visa Net*",
    titleDiscoberChargebacks: "Chargebacks Discover",
    titleAmexChargebacks: "Chargebacks Amex",
    titleChargebackDetails: "Detalles de Chargeback",
    titleKeyAccountStatistics: "Estadísticas de cuentas clave",
    tableCbDate: "Fecha de CB",
    tableCardType: "Tipo de tarjeta",
    tableCardBin: "Bin de tarjeta",
    tableLast4: "Últimos 4 dígitos",
    tableTrxDate: "Fecha de transacción",
    tableCurrency: "Moneda",
    tableReasonCode: "Código de motivo",
    tableReason: "Motivo",
    tableAuthCode: "Código de autorización",
    tableChargebackDetailsFooter: "*Chargebacks Visa Net es el conteo de chargebacks después de eliminar los RDRs que fueron mal reportados por su adquirente",
    tableFdCreateDateTime: "Fecha de Creación",
    tableCaseTypeLabel: "Tipo de Caso",
    tablePaymentDescriptor: "Descripción del Pago",
    tableTrxAmount: "Monto de la Transacción",
    legend: "Leyenda",
    fdDateTimeWeek: "Fecha",
    transactionCountCustom: "Conteo de transacciones (personalizado)",
    transctionRateCustom: "Tasa de chargeback (personalizado)",
    controlDateType: "Tipo de fecha",
    tableCreateDataTime: "Fecha y Hora de Creación",
    deflectionServices: "Servicios de Deflexión",
    deflectionDataRequests: "Solicitudes de Datos de Deflexión",
    wonDeflections: "Deflexiones Ganadas",
    amountSaved: "Monto Ahorrado",
    preventedFraudAndChargebacks: "Fraude (TC40) y Contracargos Prevenidos",
    winningPercentage: "Porcentaje de Éxito",
    deflectionDataRequestDetails: "Detalles de la Solicitud de Datos de Deflexión",
    deflection: "Deflexión",
    keyAccountStatisticsTitle: "Estadísticas Clave de la Cuenta",
    vampRate: "TASA VAMP",
    threshold: "Umbral es 1,5%",
    fraudTC40: "Fraude (TC40)",
    totalVampDisputes: "Total de Disputas VAMP",
    totalVisaTransactions: "Total de Transacciones VISA",
    currenctVampRules: "Reglas Actuales de VAMP:",
    vampUpdates: "ACTUALIZACIONES VAMP:",
    vampMath: "Todas las Disputas Visa más todos los TC40 dividido por todas las Transacciones Visa Liquidadas = tasa VAMP",
    vampTextFinal: "El umbral es 1,5% hasta enero de 2026, pero Visa planea ajustarlo... sospechamos que al alza.",
    totalFraudAndChargebackOverTimeTitle: "Total de Fraudes y Contracargos a lo Largo del Tiempo"

  },

  "pt-br": {
    titleKeyStatistics: "Estatísticas Chave",
    titleAlertStatistics: "Estatísticas de Alertas",
    titleAllAlerts: "Todas as Alertas",
    titleAlertsCountBreakdown: "Desdobramento da Contagem de Alertas",
    graphLegendAlertType: "Tipo de Alerta",
    titleOverallChargebacks: "Chargebacks Totais",
    titleAlertDetails: "Detalhes do Alerta",
    titleAlertsStatusBreakdown: "Desdobramento do Status dos Alertas",
    graphLegendStatusLabel: "Etiquetas de Status",
    graphLegendAlertUiStatus: "Status da Interface de Alerta",
    titleAlertsVsTransactions: "Alertas vs Transações",
    controlDateRange: "Intervalo de Datas",
    titleChargebacksByCardType: "Chargebacks por Tipo de Cartão",
    graphLegendCardType: "Tipo de Cartão",
    titleVisaChargebacks: "Chargebacks Visa",
    titleMastercardChargebacks: "Chargebacks Mastercard",
    titleChargebacksVsTransactions: "Chargebacks vs Transações",
    titleVisaNetChargebacks: "Chargebacks Visa Net*",
    titleDiscoberChargebacks: "Chargebacks Discover",
    titleAmexChargebacks: "Chargebacks Amex",
    titleChargebackDetails: "Detalhes do Chargeback",
    titleKeyAccountStatistics: "Estatísticas de contas-chave",
    tableCbDate: "Data de CB",
    tableCardType: "Tipo de Cartão",
    tableCardBin: "Bin do Cartão",
    tableLast4: "Últimos 4 Dígitos",
    tableTrxDate: "Data da Transação",
    tableCurrency: "Moeda",
    tableReasonCode: "Código de Motivo",
    tableReason: "Motivo",
    tableAuthCode: "Código de Autorização",
    tableChargebackDetailsFooter: "*Chargebacks Visa Net é a contagem de chargebacks após remover os RDRs que foram mal reportados pelo seu adquirente",
    tableFdCreateDateTime: "Data de Criação",
    tableCaseTypeLabel: "Tipo de Caso",
    tablePaymentDescriptor: "Descrição do Pagamento",
    tableTrxAmount: "Valor da Transação",
    legend: "Legenda",
    fdDateTimeWeek: "Data",
    transactionCountCustom: "Contagem de Transações (Personalizada)",
    transctionRateCustom: "Taxa de Chargeback (Personalizada)",
    controlDateType: "Tipo de data",
    tableCreateDataTime: "Data e Hora de Criação",
    deflectionServices: "Serviços de Deflection",
    deflectionDataRequests: "Solicitações de Dados de Deflection",
    wonDeflections: "Deflections Vencidas",
    amountSaved: "Valor Economizado",
    preventedFraudAndChargebacks: "Fraudes (TC40) e Chargebacks Prevenidos",
    winningPercentage: "Porcentagem de Sucesso",
    deflectionDataRequestDetails: "Detalhes da Solicitação de Dados de Deflection",
    deflection: "Deflection",
    keyAccountStatisticsTitle: "Estatísticas Chave da Conta",
    vampRate: "TAXA VAMP",
    threshold: "Limite é 1,5%",
    fraudTC40: "Fraude (TC40)",
    totalVampDisputes: "Total de Disputas VAMP",
    totalVisaTransactions: "Total de Transações VISA",
    currenctVampRules: "Regras Atuais do VAMP:",
    vampUpdates: "ATUALIZAÇÕES VAMP:",
    vampMath: "Todas as Disputas Visa mais todos os TC40 divididos por todas as Transações Visa Liquidadas = taxa VAMP",
    vampTextFinal: "O limite é de 1,5% até jan. de 2026, mas a Visa planeja ajustar... suspeitamos que para mais.",
    totalFraudAndChargebackOverTimeTitle: "Total de Fraudes e Chargebacks ao Longo do Tempo"
  },
  
  "pl-pl": {
    titleKeyStatistics: "Kluczowe statystyki",
    titleAlertStatistics: "Statystyki alertów",
    titleAllAlerts: "Wszystkie alerty",
    titleAlertsCountBreakdown: "Rozbicie liczby alertów",
    graphLegendAlertType: "Typ alertu",
    titleOverallChargebacks: "Całkowite chargebacki",
    titleAlertDetails: "Szczegóły alertu",
    titleAlertsStatusBreakdown: "Rozbicie statusu alertu",
    graphLegendStatusLabel: "Etykiety statusu",
    graphLegendAlertUiStatus: "Status interfejsu alertu",
    titleAlertsVsTransactions: "Alerty vs Transakcje",
    controlDateRange: "Zakres dat",
    titleChargebacksByCardType: "Chargebacki według typu karty",
    graphLegendCardType: "Typ karty",
    titleVisaChargebacks: "Chargebacki Visa",
    titleMastercardChargebacks: "Chargebacki Mastercard",
    titleChargebacksVsTransactions: "Chargebacki vs Transakcje",
    titleVisaNetChargebacks: "Chargebacki Visa Net*",
    titleDiscoberChargebacks: "Chargebacki Discover",
    titleAmexChargebacks: "Chargebacki Amex",
    titleChargebackDetails: "Szczegóły chargebacku",
    titleKeyAccountStatistics: "Statystyki kluczowych kont",
    tableCbDate: "Data CB",
    tableCardType: "Typ karty",
    tableCardBin: "Bin karty",
    tableLast4: "Ostatnie 4 cyfry",
    tableTrxDate: "Data transakcji",
    tableCurrency: "transakcji",
    tableReasonCode: "Kod powodu",
    tableReason: "Powód",
    tableAuthCode: "Kod autoryzacji",
    tableChargebackDetailsFooter: "*Chargebacki Visa Net to liczba chargebacków po usunięciu RDR-ów, które zostały błędnie zgłoszone przez twojego nabywcę",
    tableFdCreateDateTime: "Data utworzenia",
    tableCaseTypeLabel: "Typ sprawy",
    tablePaymentDescriptor: "Opis płatności",
    tableTrxAmount: "Kwota transakcji",
    legend: "Legenda",
    fdDateTimeWeek: "Data",
    transactionCountCustom: "Liczba transakcji (niestandardowa)",
    transctionRateCustom: "Stawka chargebacków (niestandardowa)",
    controlDateType: "Typ daty",
    tableCreateDataTime: "Data i godzina utworzenia",
    deflectionServices: "Usługi Deflection",
    deflectionDataRequests: "Żądania danych Deflection",
    wonDeflections: "Wygrane Deflectiony",
    amountSaved: "Zaoszczędzona kwota",
    preventedFraudAndChargebacks: "Zapobieżone oszustwa (TC40) i obciążenia zwrotne",
    winningPercentage: "Procent wygranych",
    deflectionDataRequestDetails: "Szczegóły żądań danych Deflection",
    deflection: "Deflection",
    keyAccountStatisticsTitle: "Kluczowe Statystyki Konta",
    vampRate: "WSPÓŁCZYNNIK VAMP",
    threshold: "Próg wynosi 1,5%",
    fraudTC40: "Oszustwo (TC40)",
    totalVampDisputes: "Łączna liczba sporów VAMP",
    totalVisaTransactions: "Łączna liczba transakcji VISA",
    currenctVampRules: "Aktualne zasady VAMP:",
    vampUpdates: "AKTUALIZACJE VAMP:",
    vampMath: "Wszystkie spory Visa plus wszystkie TC40 podzielone przez wszystkie rozliczone transakcje Visa = współczynnik VAMP",
    vampTextFinal: "Próg wynosi 1,5% do stycznia 2026 r., ale Visa planuje go zmienić... podejrzewamy, że w górę.",
    totalFraudAndChargebackOverTimeTitle: "Łączna liczba oszustw i obciążeń zwrotnych w czasie"
  }

};
